<div style="margin: 10px;">
    <div class="container" style="max-width: 100%;">
       <div style="padding: 30px 0px 30px 0px;">
            <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
                <li *ngFor="let item of menu_list;let i = index" class="nav-item" style="cursor:pointer" (click)="choose(item.id)">
                    <span [ngClass]="menu_type==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
                </li>
            </ul>
        </div>

        <div style="padding: 30px 0px 30px 0px;" *ngIf="menu_type=='0'">

            <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="sudgame_type" (change)="default_page()">
                <option default disabled value="-2">請選擇遊戲類型</option>
                <option *ngFor="let item of sudgame_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="status_type" (change)="default_page()">
                <option default disabled value="-2">請選擇狀態</option>
                <option *ngFor="let item of status_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

        </div>

        <div style="padding: 30px 0px 30px 0px;" *ngIf="menu_type=='1'">
            <div style="display: flex;align-items: center;">
                <!-- 搜尋電話/名稱 -->
                <div style="display: flex;align-items: center;">
                    <input
                        style="width: 60%;"
                        type="text"
                        class="form-control"
                        placeholder="請輸入電話或名稱"
                        [(ngModel)]="search_model"
                        (keyup.enter)="default_page()"
                    >
                    <button
                        class="btn btn-primary"
                        (click)="default_page()"
                    >
                        <i class="fa fa-search"></i> 搜尋
                    </button>
                </div>

                <!-- 選擇遊戲類型 -->
                <div style="display: flex;align-items: center;">
                    <select
                        class="form-control"
                        [(ngModel)]="sudgame_type"
                        (change)="default_page()"
                    >
                        <option value="-2">請選擇遊戲類型</option>
                        <option *ngFor="let item of sudgame_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>

                <!-- 日期選擇 -->
                <div class="col-md-5">
                    <app-date
                        [type]="true"
                        [time]="date_filter"
                        [timeset]="date_timeset"
                        (rangeSelected)="handleDateRangeSelected($event)"
                        (open)="open_crtol()"
                        (showDatePickered)="ShowDatePickered()"
                    ></app-date>
                </div>


            </div>
        </div>

        <div *ngIf="menu_type=='0'">
            <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata($event)">
                <ng-template let-post #operation_dk>
                    <div *ngIf="post.key == 'type'">
                        {{ typeMap.get(post.val.type) || '未知類型' }}
                    </div>
                    <div *ngIf="post.key == 'duration'">
                        {{ formatDuration(post.val.duration) }}
                    </div>

                    <div *ngIf="post.key == 'status'">
                        <div *ngIf="post.val.status == '0'">停用</div>
                        <div *ngIf="post.val.status == '1'">啟用</div>
                    </div>
                    <div *ngIf="post.key == 'gg'">
                        <div data-toggle="modal" data-target=".bd-example-modal-xl" (click)="Tmpdata = post.val">
                            <i class="fa fa-list-alt" title="修改入場費" aria-hidden="true" style="color: teal;cursor: pointer;" ></i>
                        </div>
                    </div>
                </ng-template>
            </app-table-v2>

            <div  *ngIf="data.length == 0">
                目前無資料
            </div>
            <app-pagnation (callback)="callback($event)" [data]="pageobjstr"  *ngIf="data.length > 0"></app-pagnation>
        </div>
        <div *ngIf="menu_type=='1'">
            <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent1" [data]="data" (sortdata)="handlesortdata($event)">
                <ng-template let-post #operation_dk>
                    <div *ngIf="post.key == 'duration'">
                        {{ formatDuration(post.val.duration) }}
                    </div>
                    <div *ngIf="post.key == 'gg'">
                        <div data-toggle="modal" data-target=".bd-example-modal-xl" (click)="open_detail(post.val.id);">
                            <i class="fa fa-list-alt" title="查看詳細資料" aria-hidden="true" style="color: teal;cursor: pointer;" ></i>
                        </div>
                    </div>
                </ng-template>
            </app-table-v2>

            <div  *ngIf="data.length == 0">
                目前無資料
            </div>
            <app-pagnation (callback)="callback($event)" [data]="pageobjstr"  *ngIf="data.length > 0"></app-pagnation>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>


<div
    class="modal fade bd-example-modal-xl" tabindex="-1"
    role="dialog"  data-keyboard="false" data-backdrop="static"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" *ngIf="menu_type=='0'">修改入場費</h5>
                <h5 class="modal-title" *ngIf="menu_type=='1'">查看詳細資料</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body" *ngIf="menu_type=='0'">
               <div class="form-group row align-items-center mb-3">
                    <label for="diamondInput" class="col-sm-2 col-form-label">鑽石數</label>
                    <div class="col-sm-4">
                        <input
                            id="diamondInput"
                            type="number"
                            class="form-control diamond-input"
                            [(ngModel)]="Tmpdata.diamond"
                            placeholder="請輸入鑽石數"
                        />
                    </div>
                </div>
            </div>

             <div class="modal-body" *ngIf="menu_type=='1'">
                <app-table-v2  *ngIf="data1.length > 0" [type]="1" [tcontent]="tcontent2" [data]="data1" (sortdata)="handlesortdata($event)">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'gg'">
                            <div data-toggle="modal" data-target=".bd-example-modal-xl">
                                <i class="fa fa-list-alt" title="查看詳細資料" aria-hidden="true" style="color: teal;cursor: pointer;" ></i>
                            </div>
                        </div>
                    </ng-template>
                </app-table-v2>

                <div  *ngIf="data1.length == 0">
                    目前無資料
                </div>
                <app-pagnation (callback)="callback($event)" [data]="pageobjstr1"  *ngIf="data1.length > 0"></app-pagnation>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer" *ngIf="menu_type=='0'">
                <button type="button"   class="btn btn-primary" data-dismiss="modal" (click)="save()">確認</button>
                <button type="button"   class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>

            <div class="modal-footer" *ngIf="menu_type=='1'">
                <button type="button"   class="btn btn-primary" data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>


